// Mock data for SS Consultancy — Premium Financial & Wealth Advisory

export const companyInfo = {
  name: "SS Consultancy",
  tagline: "Premium Financial & Wealth Advisory",
  founder: "Swarnava Sengupta",
  credentials: "MBA Finance · AMFI-Registered Mutual Fund Distributor (ARN: 288129)",
  arn: "ARN: 288129",
  establishedDate: "December 2024",
  serviceArea: "Chandannagar · Chinsurah · Hooghly",
  address: "Radha Apartment, Chandannagar, Hooghly, West Bengal, PIN-712136",
  phone: "+91-8961317137",
  whatsapp: "+91-7003535343",
  whatsappRaw: "917003535343",
  email: "info@ssconsultancy.com",
  googleCalendarLink: "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ33IH-rkhoua-DMURPyIeY7pErg1e8tB-Sj_NnO4fjx6qqsf_pYC_htF9UPXbGsVNZmUAzRNGjk",
  social: {
    linkedin: "https://www.linkedin.com/in/swarnava-sengupta",
    instagram: "https://www.instagram.com/ss.contsultancy",
    facebook: "https://www.facebook.com/profile.php?id=61567336492776"
  }
};

export const services = [
  {
    id: 1,
    title: "Portfolio Review",
    description: "Comprehensive analysis of your existing investment portfolio with optimization recommendations.",
    icon: "pieChart",
    featured: true
  },
  {
    id: 2,
    title: "Investment Review",
    description: "Detailed evaluation of your investment strategy and individual investment choices.",
    icon: "trendingUp",
    featured: true
  },
  {
    id: 3,
    title: "Policy Review",
    description: "Thorough examination of your insurance policies to ensure adequate coverage.",
    icon: "shield",
    featured: true
  },
  {
    id: 4,
    title: "Free Financial Health-Checkup",
    description: "Complimentary comprehensive assessment of your overall financial health.",
    icon: "activity",
    featured: true,
    isFree: true
  },
  {
    id: 5,
    title: "Retirement Planning",
    description: "Long-term retirement strategies focused on maintaining your desired lifestyle.",
    icon: "target",
    featured: true
  },
  {
    id: 6,
    title: "Tax Planning & Filing",
    description: "Complete tax filing services with optimization strategies to minimize liability.",
    icon: "calculator",
    featured: true
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rahul Sharma",
    role: "Business Owner",
    location: "Chinsurah, Hooghly",
    rating: 5,
    text: "Swarnava restructured my mutual fund portfolio with a clear retirement target. Transparent, methodical, and zero pushy product selling. A genuinely client-first advisor in Hooghly.",
    avatar: "RS",
    service: "Retirement Blueprinting"
  },
  {
    id: 2,
    name: "Priya Gupta",
    role: "Software Engineer",
    location: "Chandannagar, Hooghly",
    rating: 5,
    text: "Found SS Consultancy while searching for a financial advisor in Chandannagar. The education-fund plan for my daughter is on track and the SIP reviews every quarter are a huge relief.",
    avatar: "PG",
    service: "Wealth Management"
  },
  {
    id: 3,
    name: "Amit Banerjee",
    role: "Marketing Manager",
    location: "Kolkata, WB",
    rating: 5,
    text: "Saved a meaningful chunk on tax this year through smart 80C + NPS structuring. The plan was explained on a single page — no jargon, no surprises. Highly recommend.",
    avatar: "AB",
    service: "Tax Optimization"
  }
];

export const aboutContent = {
  mission: "SS Consultancy is a pure-play financial advisory built for individuals, families and small businesses across Chandannagar, Chinsurah and the wider Hooghly region. Founded in December 2024 by Swarnava Sengupta, we offer transparent, fee-aware, AMFI-registered guidance — not product sales.",
  vision: "To be Hooghly's most trusted independent financial advisor — known for institutional-grade research, plain-language plans and measurable client outcomes.",
  values: [
    "Fiduciary mindset — your interest first, always",
    "Plain-English plans, no jargon",
    "AMFI-registered and compliance-led",
    "Long-term relationships over one-time transactions"
  ],
  founderStory: "With an MBA in Finance and 3+ years advising clients across Hooghly, Swarnava blends institutional research with on-the-ground understanding of local investor needs. Every plan starts with a free diagnostic and ends with a one-page roadmap."
};

export const blogPosts = [
  {
    id: 1,
    title: "Smart Wealth & Investment Strategies for 2026",
    excerpt: "Discover the most effective, risk-adjusted investment approaches tailored for the current 2026 market dynamics and economic conditions.",
    category: "Investment Planning",
    readTime: "5 min read",
    publishDate: "May 10, 2026",
    featured: true
  },
  {
    id: 2,
    title: "Comprehensive Tax Planning Guide for FY 2026-27",
    excerpt: "Your complete roadmap to optimizing deductions, understanding current tax slabs, and minimizing liability for the ongoing financial year.",
    category: "Tax Planning",
    readTime: "8 min read",
    publishDate: "April 15, 2026",
    featured: true
  },
  {
    id: 3,
    title: "Retirement Blueprint: How to Secure a Guaranteed Lifetime Corpus",
    excerpt: "Why aligning early with a structured retirement model is crucial to beat inflation and maintain your dream lifestyle permanently.",
    category: "Retirement Planning",
    readTime: "6 min read",
    publishDate: "May 2, 2026",
    featured: false
  }
];

export const quickLinks = [
  { title: "About Us", href: "#about" },
  { title: "Our Services", href: "#services" },
  { title: "Testimonials", href: "#testimonials" },
  { title: "Insights & Resources", href: "#insights" },
  { title: "Contact Us", href: "#contact" },
  { title: "Schedule a Consultation", href: companyInfo.googleCalendarLink, external: true }
];

export const resources = [
  {
    category: "Financial Calculators",
    items: [
      { name: "SIP Calculator", type: "sip" },
      { name: "EMI Calculator", type: "emi" },
      { name: "Retirement Calculator", type: "retirement" }
    ]
  },
  {
    category: "Educational Resources",
    items: [
      { name: "Wealth Management Guide", type: "guide" },
      { name: "Tax Planning Checklist", type: "checklist" },
      { name: "Retirement Roadmap", type: "roadmap" },
      { name: "Insurance Needs Analysis", type: "analysis" }
    ]
  }
];

export const marketUpdates = [
  {
    id: 1,
    title: "Market Outlook for Q1 2025",
    summary: "Key trends, sectoral opportunities and risk flags for Indian equity and debt markets.",
    date: "Dec 20, 2024",
    type: "market-analysis"
  },
  {
    id: 2,
    title: "RBI Policy Impact on Investments",
    summary: "How the latest repo decision changes your debt-fund and FD strategy.",
    date: "Dec 18, 2024",
    type: "policy-update"
  },
  {
    id: 3,
    title: "Tax Changes for FY 2024-25",
    summary: "What the new regime means for salaried investors in Hooghly.",
    date: "Dec 15, 2024",
    type: "tax-update"
  }
];

export const upcomingEvents = [
  {
    id: 1,
    title: "Wealth Planning Workshop",
    date: "Jan 15, 2025",
    time: "6:00 PM - 8:00 PM",
    location: "Online",
    description: "An open workshop on personal wealth strategy, asset allocation and SIP design."
  },
  {
    id: 2,
    title: "Tax Saving Strategies Seminar",
    date: "Jan 25, 2025",
    time: "7:00 PM - 9:00 PM",
    location: "Chandannagar Community Hall",
    description: "Discover lawful ways to minimise tax liability for FY 2024-25 with worked examples."
  },
  {
    id: 3,
    title: "Retirement Planning Masterclass",
    date: "Feb 5, 2025",
    time: "2:00 PM - 5:00 PM",
    location: "Online",
    description: "Comprehensive session on building a robust retirement corpus with real client case studies."
  }
];
